export function getMoneyFormat(value: string | number): string {
    return "$" + value.toLocaleString("en-US", { style: "decimal" })
}
